import React, { Component } from 'react';
import { observer, inject} from 'mobx-react';
import { LargeButton, ButtonType } from '@checkmarx/cx-ui';
import PortalTextBox from '../../portal/portalTextBox';
import ValidationTopErrorMessage from '../../portal/controls/validationTopErrorMessage';
import RestrictionsTooltip from '../../portal/controls/restrictionsTooltip/restrictionsTooltip';

@inject('translationsStore', 'firstAdminRegisterationStore', 'passwordPoliciesStore','configurationsStore') @observer
export default class FirstAdminRegisterForm extends Component {

    componentWillMount() {
        this.props.passwordPoliciesStore.updatePasswordPolicies(this.props.configurationsStore.defaultTenantName);
    }

    componentWillUnmount() {
         this.props.firstAdminRegisterationStore.resetFirstAdminValues();
    }

    handleFirstNameChange = e => this.props.firstAdminRegisterationStore.setFirstName(e.target.value);
    handleFirstNameOnBlur = e => this.props.firstAdminRegisterationStore.validateFirstName();

    handleLastNameChange = e => this.props.firstAdminRegisterationStore.setLastName(e.target.value);
    handleLastNameOnBlur = e => this.props.firstAdminRegisterationStore.validateLastName();
    
    handleUserNameChange = e => this.props.firstAdminRegisterationStore.setUserName(e.target.value);
    handleUserNameOnBlur = e => this.props.firstAdminRegisterationStore.validateUserName();

    handleEmailChange = e => this.props.firstAdminRegisterationStore.setEmail(e.target.value);
    handleEmailOnBlur = e => this.props.firstAdminRegisterationStore.validateEmail();

    handlePasswordChange = e => {
        this.props.firstAdminRegisterationStore.setPassword(e.target.value);
        this.props.firstAdminRegisterationStore.validatePassword();
    };

    handleConfirmedPasswordOnChange = e => {
        this.props.firstAdminRegisterationStore.setConfirmedPassword(e.target.value);
        this.props.firstAdminRegisterationStore.validateMatchPassword();
    };
    
    handleSubmitForm = (e) => {
        e.preventDefault();
        this.props.firstAdminRegisterationStore.registerErrorMessage = '';
        const isValid = this.props.firstAdminRegisterationStore.validateForm();

        if (isValid === false) {
            return;
        }

        this.props.firstAdminRegisterationStore.createFirstAdmin().then(() => {
            this.props.onFirstAdminRegistered();
        });
    };

    render() {

        const { values }  = this.props.firstAdminRegisterationStore;

        return(
            <div className='login-form'>
                <div className='general-form-wrapper first-admin-registration'>
                    <ValidationTopErrorMessage errorMessage={this.props.firstAdminRegisterationStore.registerErrorMessage} />
                    <div className='welcome-message-wrapper'>
                        <span>
                            {this.props.translationsStore.translate('WELCOME')}
                        </span>
                        <div>
                            {this.props.translationsStore.translate('CREATE_YOUR_ADMINISTRATOR_ACCOUNT')}
                        </div>
                    </div>
                    <form onSubmit={this.handleSubmitForm}>
                        <div className='form-row' style={{
                            justifyContent: 'space-between'
                        }}>
                            <div style={{marginRight: '5%'}}>
                                <PortalTextBox
                                    hintText={this.props.translationsStore.translate('FIRST_NAME')}
                                    floatingLabelText={this.props.translationsStore.translate('FIRST_NAME')}
                                    disabled={this.props.firstAdminRegisterationStore.inProgress}
                                    onChange={this.handleFirstNameChange}
                                    onBlur={this.handleFirstNameOnBlur}
                                    errorText={this.props.firstAdminRegisterationStore.firstNameValidationMessage}
                                    width='100%'
                                    value={values.firstName}
                                />
                            </div>
                            <div>
                                <PortalTextBox
                                    hintText={this.props.translationsStore.translate('LAST_NAME')}
                                    floatingLabelText={this.props.translationsStore.translate('LAST_NAME')}
                                    disabled={this.props.firstAdminRegisterationStore.inProgress}
                                    onChange={this.handleLastNameChange}
                                    onBlur={this.handleLastNameOnBlur}
                                    errorText={this.props.firstAdminRegisterationStore.lastNameValidationMessage}
                                    width='100%'
                                    value={values.lastName}
                                />
                            </div>
                        </div>
                        <div>
                            <div>
                                <PortalTextBox
                                    hintText={this.props.translationsStore.translate('USER_NAME')}
                                    floatingLabelText={this.props.translationsStore.translate('USER_NAME')}
                                    disabled={this.props.firstAdminRegisterationStore.inProgress}
                                    onChange={this.handleUserNameChange}
                                    onBlur={this.handleUserNameOnBlur}
                                    errorText={this.props.firstAdminRegisterationStore.userNameValidationMessage}
                                    width='100%'
                                    value={values.userName}
                                />
                            </div>
                        </div>
                        <div>
                            <div>
                                <PortalTextBox 
                                    hintText={this.props.translationsStore.translate('EMAIL')}
                                    floatingLabelText={this.props.translationsStore.translate('EMAIL')}
                                    disabled={this.props.firstAdminRegisterationStore.inProgress}
                                    onChange={this.handleEmailChange}
                                    onBlur={this.handleEmailOnBlur}
                                    errorText={this.props.firstAdminRegisterationStore.emailValidationMessage}
                                    width='100%'
                                    value={values.email}
                                />
                            </div>
                        </div>
                        <div>
                            <div>
                                <PortalTextBox 
                                    hintText={this.props.translationsStore.translate('PASSWORD')}
                                    floatingLabelText={this.props.translationsStore.translate('PASSWORD')}
                                    disabled={this.props.firstAdminRegisterationStore.inProgress}
									includeContentVisibilityToggle
									triggerHelpTooltipOnFocus
									helpTooltipPlacement="right"
									helpTooltipText={
										<RestrictionsTooltip isInputPristine={ Boolean(values.password) }
                                            restrictions={this.props.passwordPoliciesStore.PasswordRestrictions}
											failingRestrictions={ this.props.firstAdminRegisterationStore.passwordValidationMessage || [] } />
									}
                                    onChange={this.handlePasswordChange}
                                    type='password'
                                    width='100%'
                                    value={values.password}
                                />
                            </div>
                        </div>
                        <div>
                            <div>
                                <PortalTextBox 
                                    hintText={this.props.translationsStore.translate('RETYPE_PASSWORD')}
                                    floatingLabelText={this.props.translationsStore.translate('RETYPE_PASSWORD')}
                                    disabled={this.props.firstAdminRegisterationStore.inProgress}
                                    errorText={this.props.firstAdminRegisterationStore.passwordConfirmedValidationMessage}
                                    onChange={this.handleConfirmedPasswordOnChange}
									triggerHelpTooltipOnFocus
									type='password'
                                    width='100%'
                                    value={values.confirmedPassword}
                                />
                            </div>
                        </div>
                        <div className='button-wrapper'>
                            <LargeButton
                                type='submit'
                                id='btnUpdatePasswordSubmit'
                                dataCy='update-password-button'
                                inProgress={this.props.firstAdminRegisterationStore.inProgress}
                                text={this.props.translationsStore.translate('REGISTER')}
                                style={{marginTop: '30px'}}
                            />
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}